import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { GoogleAnalyticsService } from '@app/core/analytics/google-analytics.service';
import { Application, Document } from '@app/core/stingray-api/models';
import { DocumentsService } from '@app/core/stingray-api/services';
import { finalize, zip } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { MatButton } from '@angular/material/button';
import { LoadingButtonComponent } from '../../loading-button/loading-button.component';
import { MatOption } from '@angular/material/core';

import { MatSelect } from '@angular/material/select';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';

export interface FileApplicationDialogData {
  documents: Document[];
  applications: Application[];
}

@Component({
    selector: 'unite-file-application-dialog',
    templateUrl: './file-application-dialog.component.html',
    styleUrls: ['./file-application-dialog.component.scss'],
    imports: [MatDialogTitle, TranslateModule, ReactiveFormsModule, MatDialogContent, MatFormField, MatLabel, MatSelect, MatOption, MatDialogActions, LoadingButtonComponent, MatButton, MatDialogClose]
})
export class FileApplicationDialogComponent {

  documents: Document[];
  documentFormGroup: UntypedFormGroup;

  showCustomerInput = false;

  loadingSave = false;
  applicationsAll: Application[] = [];


  constructor(private documentsService: DocumentsService,
    private formBuilder: UntypedFormBuilder,
    private matDialogRef: MatDialogRef<FileApplicationDialogComponent>,
    private googleAnalyticsService: GoogleAnalyticsService,
    @Inject(MAT_DIALOG_DATA) private fileEditData: FileApplicationDialogData) {
    this.documentFormGroup = this.formBuilder.group({
      application: [, [Validators.required]]
    });

    this.documents = this.fileEditData.documents;
    this.applicationsAll = this.fileEditData.applications;
  }


  /**
   * Save the document
   */
  save() {
    if (this.documentFormGroup.valid) {
      this.loadingSave = true;
      this.googleAnalyticsService.trackEvent('document', 'bulk edit', 'application');

      const updates = this.documents.map(document => {
        if (document.applications.findIndex(application =>
          application.id === this.documentFormGroup.get('application').value.id) === -1) {
          document.applications.push(this.documentFormGroup.get('application').value);
        }

        return this.documentsService.patchDocument({
          id: document.id, body: [
            { path: 'applications', value: document.applications, op: 'replace' },
          ]
        });
      });

      forkJoin(updates).pipe(
        finalize(() => {
          this.loadingSave = false;
        })
      ).subscribe(documents => {
        this.matDialogRef.close(documents);
      });
    }
  }
}
